import { extend } from 'flarum/common/extend';
import ArticleSliderItem from 'flarum/orell-articles/components/ArticleSliderItem';
import CreateReviewActionButton from '../components/CreateReviewActionButton';

/**
 * `reviewsState` and `label` are optional attrs contributed by callers that render
 * ArticleSliderItem inside a reviews context; they are not part of orell-articles'
 * own ArticleSliderItemAttrs.
 */
type ReviewsSliderAttrs = { reviewsState?: any; label?: string };

export default function () {
	extend(ArticleSliderItem.prototype, 'actionButtons', function (items) {
		// The slider infrastructure hands the article to each slide as `item` (SliderItemAttrs).
		const { item: article } = this.attrs;
		const { reviewsState, label } = this.attrs as typeof this.attrs & ReviewsSliderAttrs;

		items.add('create-review-button', <CreateReviewActionButton article={article} reviewsState={reviewsState} label={label} />, 70);
	});
}
